module.exports = __webpack_public_path__ + "static/hilton-inverness.9b48707d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hilton-inverness.jpg
// module id = 632
// module chunks = 262104617495404